module.exports = __webpack_public_path__ + "static/media/link_chain.b84a70fe.svg";